import axios from '@/axios'

export default {
  fetchSearchHistories({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.get('/admin/search-history', { params: payload })
        .then((response) => {
          commit('SET_SEARCH_HISTORIES', response.data.results)
          commit('SET_TOTAL_SEARCH_HISTORIES', response.data.totalResults)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deleteSearchHistories({ commit }, historyIds) {
    return new Promise((resolve, reject) => {
      axios.delete('/admin/search-history', { data: { ids: historyIds } })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
